import { TransactionDetailComponent } from './../transaction/transaction-detail/transaction-detail.component';
import { AwsUtil } from './../authentication/aws.service';
import { AppConfig } from './../app.config';
import {
    ProjectionData,
    ContractualFlowData,
    ExplainData,
    CorrectionData,
    GetTransactionDetailsRequest,
    GetTransactionDetailsResult,
    WebApiEndpoints
} from '@liquitics/transaction';
import { Observable } from 'rxjs';
import { AmChartsService } from '@amcharts/amcharts3-angular';
import { ExplainService } from './explain.service';
import { DashboardEventService } from '../dashboard/dashboard-event.service';
import { Component, OnInit, Input } from '@angular/core';
import { SnapshotService } from './../snapshot/snapshot.service';
import {
    trigger,
    state,
    style,
    animate,
    transition
} from '@angular/animations';
import { MatDialog } from '@angular/material/dialog';

@Component({
    selector: 'app-explain-tables',
    templateUrl: './explain-tables.component.html',
    styleUrls: ['./explain-tables.component.scss'],
    animations: [
        trigger('flyInOut', [
            state('in', style({ opacity: 1, transform: 'translateX(0)' })),
            transition('void => *', [
                style({
                    opacity: 0,
                    transform: 'translateX(100%)'
                }),
                animate('0.2s ease-in')
            ]),
            transition('* => void', [
                style({
                    opacity: 0,
                    transform: 'translateX(-100%)'
                })
            ])
        ])
    ]
})
export class ExplainTablesComponent {
    interdeskFundingTableData: ProjectionData[] = [];
    clientLevelFundingTableData: ProjectionData[] = [];
    predictionTableData: ProjectionData[] = [];
    correctionTableData: CorrectionData[] = [];
    contractualFlowTableData: ContractualFlowData[] = [];
    unexpectedFlowTableData: ContractualFlowData[] = [];
    topNData: any[] = [];
    topNDataByType: { [key: string]: any[] } = {};

    interdeskFundingTableDataToShow: ProjectionData[] = [];
    clientLevelFundingTableDataToShow: ProjectionData[] = [];
    predictionTableDataToShow: ProjectionData[] = [];
    correctionTableDataToShow: CorrectionData[] = [];
    contractualFlowTableDataToShow: ContractualFlowData[] = [];
    unexpectedFlowTableDataToShow: ContractualFlowData[] = [];
    topNDataToShow: any[] = [];
    topNDataByTypeToShow: any[] = [];

    selectedDataType = 'top';
    selectedLiquidityMode = 'gross';
    selectedCurrencyIndex = -1;
    headerColor: string;

    constructor(private appConfig: AppConfig, public dialog: MatDialog, private awsUtil: AwsUtil) {
    }

    isPositive(value) {
        return Number.parseFloat(value) >= 0;
    }
    isNegative(value) {
        return Number.parseFloat(value) < 0;
    }

    currencyClass() {
        if (this.selectedCurrencyIndex === -1) {
            return '';
        } else {
            return 'currency' + this.selectedCurrencyIndex;
        }
    }

    getHeaderColor() {
        return this.headerColor;
    }

    show(liquidityMode: string, dataType: string, topType?: string) {
        let directionToUse;
        if (liquidityMode === 'in') {
            directionToUse = 'REC';
        } else if (liquidityMode === 'out') {
            directionToUse = 'PAY';
        }
        this.interdeskFundingTableDataToShow = this.interdeskFundingTableData
            .filter((data => { return (directionToUse) ? data.direction === directionToUse : true; }));
        this.clientLevelFundingTableDataToShow = this.clientLevelFundingTableData
            .filter((data => { return (directionToUse) ? data.direction === directionToUse : true; }));
        this.predictionTableDataToShow = this.predictionTableData
            .filter((data => { return (directionToUse) ? data.direction === directionToUse : true; }));
        this.correctionTableDataToShow = this.correctionTableData
            .filter((data => { return (directionToUse) ? data.direction === directionToUse : true; }));
        this.contractualFlowTableDataToShow = this.contractualFlowTableData
            .filter((data => { return (directionToUse) ? data.direction === directionToUse : true; }));
        this.unexpectedFlowTableDataToShow = this.unexpectedFlowTableData
            .filter((data => { return (directionToUse) ? data.direction === directionToUse : true; }));
        this.topNDataToShow = this.topNData
            .filter((data => { return (directionToUse) ? data.direction === directionToUse : true; }));
        if (topType) {
            this.topNDataByTypeToShow = this.topNDataByType[topType]
                .filter((data => { return (directionToUse) ? data.direction === directionToUse : true; }));
        }
        this.selectedLiquidityMode = liquidityMode;
        this.selectedDataType = dataType;
    }

    showTransactionDetails(explainRow: any) {
        const request = new GetTransactionDetailsRequest();
        request.includeExpected = 'true';
        request.operatingDate = this.appConfig.getTodayString();
        request.currency = explainRow.currency;
        request.settleDate = explainRow.date;
        request.direction = explainRow.direction;
        request.desk = explainRow.desk;
        request.clientGroup = explainRow.targetName;
        request.productType = explainRow.productType;
        request.countAmountThresholds = [100, 50, 20, 10].map((n) => {
            return Math.pow(10, Math.floor(Math.log10(explainRow.absFlowAmount / n)));
        });
        request.countAmountThresholds.unshift(0);
        const dialogRef = this.dialog.open(TransactionDetailComponent, {
            width: '80%',
            height: '85%',
            data: {
                request: request,
                transactionDetailsResultPromise: this.awsUtil.webAPICall(WebApiEndpoints.QueryTransactionDetails, request)
            }
        });
        dialogRef.afterClosed().subscribe({
            next: result => {
                // console.log('The dialog was closed');
            }
        });
    }
}
